module.exports = __webpack_public_path__ + "media/images/emblems/Mellikon-blason-1b5bd858204217836665f059ff88e096.png";